module.exports = __webpack_public_path__ + "img/3.522f2cd6.jpeg";